var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53027 15.25C6.99747 15.25 12.2939 15.9812 17.327 17.3512C18.054 17.5491 18.7803 17.0086 18.7803 16.2551V15.25M3.03027 1V1.75C3.03027 2.16421 2.69449 2.5 2.28027 2.5H1.53027M1.53027 2.5V2.125C1.53027 1.50368 2.03395 1 2.65527 1H19.5303M1.53027 2.5V11.5M19.5303 1V1.75C19.5303 2.16421 19.8661 2.5 20.2803 2.5H21.0303M19.5303 1H19.9053C20.5266 1 21.0303 1.50368 21.0303 2.125V11.875C21.0303 12.4963 20.5266 13 19.9053 13H19.5303M21.0303 11.5H20.2803C19.8661 11.5 19.5303 11.8358 19.5303 12.25V13M19.5303 13H3.03027M3.03027 13H2.65527C2.03395 13 1.53027 12.4963 1.53027 11.875V11.5M3.03027 13V12.25C3.03027 11.8358 2.69449 11.5 2.28027 11.5H1.53027M14.2803 7C14.2803 8.65685 12.9371 10 11.2803 10C9.62342 10 8.28027 8.65685 8.28027 7C8.28027 5.34315 9.62342 4 11.2803 4C12.9371 4 14.2803 5.34315 14.2803 7ZM17.2803 7H17.2878V7.0075H17.2803V7ZM5.28027 7H5.28777V7.0075H5.28027V7Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.4d7134574538cd54309e9092c1157b0a.svg";
export { ForwardRef as ReactComponent };